import React, { useEffect } from 'react';
import { buildBookWidgetsUrl } from '../../util/buildBookWidgetsUrl.js';
import 'jwt-decode';
import { LtiModal } from '../lti-modal/LtiModal.js';
import '../lti-modal/context/LtiResourceContext.js';
import { isAssignmentLTI } from './utils.js';
import useAnalytics from '../../hooks/useAnalytics.js';
import { ANALYTICS_EVENT_TYPES } from '../../hooks/constants/Analytics.js';

function transformAssignmentMaterial(material, isOwner) {
    if (isOwner) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { assignment: omitAssignment, ...materialWithoutAssignment } = material;
        return {
            ...materialWithoutAssignment,
        };
    }
    return {
        ...material,
        assignmentId: material.assignment.id,
    };
}
function getMaterialAudience(material) {
    if (!material.assignment && !material.share)
        return undefined;
    if (isAssignmentLTI(material)) {
        return {
            groupName: material.assignment.groupName,
            schoolName: material.assignment.schoolName,
        };
    }
    return {
        groupName: material.share?.groupName,
        schoolName: material.share?.schoolName,
    };
}
function StartLTIExercise({ id, material, module, platformName, studioLanguage, ltipsUrl, onClose, tokenAccessor, headerElement, translations, isOwner, analyticsData, studioGroup, }) {
    const url = buildBookWidgetsUrl({
        platformName,
        studioLanguage,
        ltipsUrl,
        ltiUserMaterial: isAssignmentLTI(material) ? transformAssignmentMaterial(material, isOwner) : material,
        module,
        audience: getMaterialAudience(material),
    });
    const analytics = useAnalytics();
    useEffect(() => {
        const captureEvent = async () => {
            const token = await tokenAccessor.tokenGetter();
            if (analyticsData && token) {
                analytics.capture({
                    eventType: ANALYTICS_EVENT_TYPES.USER_MATERIAL_ACCESSED,
                    objectId: material.id,
                    analyticsData,
                }, token);
            }
        };
        captureEvent();
    }, [analytics, analyticsData, tokenAccessor, material]);
    return (React.createElement(LtiModal, { id: id, headerElement: headerElement, loginUrl: url, onClose: onClose, closeTitle: translations.close, tokenAccessor: tokenAccessor, iframeTitle: material.name, studioGroup: studioGroup }));
}

export { StartLTIExercise as default };
